export const BASE_URL = "https://marketing.medlucy.com/api";
export const TOKEN = process.env.NEXT_PUBLIC_STRAPI_API_TOKEN || "";
export const STRAPI_HEADERS = {
  method: "GET",
  headers: {
    "Content-Type": "application/json",
    Authorization: `Bearer ${TOKEN}`,
  },
};
